import HENGE from "@henge-inc/global-types";
import HUI from "@henge-inc/ui/v1_2";
import { ICON as ICON_v1_1 } from "@henge-inc/ui/v1_1";
import { motion } from "motion/react";
import React from "react";

const variants = {
  open: {
    pointerEvents: "auto",
    opacity: 1,
    top: "calc(50% - 16px)",
    transform: "translate(-50%, -100%)",
    zIndex: 1,
  },
  closed: {
    pointerEvents: "none",
    opacity: 0,
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  },
} as const;

export const UploadPanel = () => {
  return (
    <>
      <motion.div
        variants={variants}
        initial={variants.closed}
        animate={variants.open}
        exit={variants.closed}
        transition={HUI.framerMotionTransition.spring}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <HUI.Popover
          arrowFace={HENGE.POSITION_FACE.bottom}
          arrowAlign={HENGE.FLEX_ALIGN.center}
          contentDirection={HENGE.FLEX_DIRECTION.column}
          borderRadius={16}
        >
          <div
            className={
              "flex flex-row flex-nowrap justify-center items-center gap-1"
            }
          >
            <HUI.Button
              kind={HENGE.BUTTON_KIND.borderless}
              colour={HENGE.GRAYSCALE_COLOUR.mono}
              size={HENGE.DETAILED_SIZE.xSmall}
              textStyleProps={{
                kind: HENGE.TEXT_KIND.small,
                weight: HENGE.TEXT_WEIGHT.medium,
                whiteSpace: HENGE.TEXT_WHITE_SPACE.nowrap,
              }}
              leftIcon={{
                icon: ICON_v1_1.UploadCloud,
                kind: HENGE.ICON_KIND.regular,
                size: HENGE.DETAILED_SIZE.xSmall,
              }}
              onClick={() => {
                const openDropzoneButton =
                  document.getElementById("open--dropzone");

                if (openDropzoneButton) {
                  openDropzoneButton.click();
                }
              }}
            >
              Upload
            </HUI.Button>
          </div>
        </HUI.Popover>
      </motion.div>
    </>
  );
};
